import { render, staticRenderFns } from "./BookingProceedButton.vue?vue&type=template&id=8e891b48&scoped=true&"
import script from "./BookingProceedButton.vue?vue&type=script&lang=ts&"
export * from "./BookingProceedButton.vue?vue&type=script&lang=ts&"
import style0 from "./BookingProceedButton.vue?vue&type=style&index=0&id=8e891b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e891b48",
  null
  
)

export default component.exports